import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { bibShape } from '@bibliocommons/bc-prop-types';

import BaseCancelHoldWorkflowView from './BaseCancelHoldWorkflowView';

export class SingleCancelHoldWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getMetadataId() {
    const { bib } = this.props;
    return (bib && bib.get('metadataId')) || null;
  }

  handleCancelHold({ shelfState }) {
    const { accountId, holdId, messagingId, workflowId } = this.props;
    const metadataId = this.getMetadataId();
    this.props.cancelHold({
      accountId,
      metadataIds: metadataId ? [metadataId] : [],
      holdIds: [holdId],
      shelfState,
      messagingId,
      workflowId
    });
  }

  render() {
    const { handleClose, accountId, holdId, isLoading, bib, shelves, messagingId } = this.props;
    const showShelfPrompt = !shelves.get(this.getMetadataId());

    return (
      <BaseCancelHoldWorkflowView
        testId={`cancel-holds-overlay-${bib && bib.get('id')}`}
        handleClose={handleClose}
        handleCancelHold={this.handleCancelHold}
        accountId={accountId}
        holdIds={Immutable.List.of(holdId)}
        isLoading={isLoading}
        showShelfPrompt={showShelfPrompt}
        bibs={Immutable.List.of(bib)}
        messagingId={messagingId}
      />
    );
  }
}

SingleCancelHoldWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  cancelHold: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdId: PropTypes.string,
  isLoading: PropTypes.bool,
  bib: bibShape.isRequired,
  shelves: ImmutablePropTypes.map.isRequired,
  messagingId: PropTypes.string,
  workflowId: PropTypes.string
};

export default SingleCancelHoldWorkflowView;
